export const themeconfig = {
  palette: {
    primary: {
      main: "#00786a",
      light: "#74e3bf",
    },
    secondary: {
      main: "#072663",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 8,
      },
    },
  },
};
